import { Injectable } from '@angular/core';
import { Actions, Store } from '@ngxs/store';
import { BaseQueries } from './base/base.queries';
import { AppStateModel } from './app.state';

@Injectable()
export class AppQueries  extends BaseQueries {
  readonly states$ = this.store.select(state => (state['App'] as AppStateModel).states);
  readonly token$ = this.store.select(state => (state['App'] as AppStateModel).token);
  readonly resources$ = this.store.select(state => (state['App'] as AppStateModel).resources);
  readonly lifeHeroResources$ = this.store.select(state => (state['App'] as AppStateModel).lifeHeroResources);
  readonly sales$ = this.store.select(state => (state['App'] as AppStateModel).sales);
  readonly lifeHeroProducts$ = this.store.select(state => (state['App'] as AppStateModel).lifeHeroProducts);
  readonly userProfile$ = this.store.select(state => (state['App'] as AppStateModel).userProfile);
  constructor(
    private store: Store,
    protected actions$: Actions
  ) { super(actions$); }
}
